module.exports = __webpack_public_path__ + "static/media/home_banner_6.a4c588a5.jpg";